import { ProductTileProps } from '@pb/components'
import { createAction } from 'redux-act'

import {
  ErrorProps,
  FavouritesState,
  HiddenFavouritesData,
  AddToBagVerificationData,
} from './types'

const fetchFavouritesStart = createAction('favourites - fetch favourites start')
const fetchFavouritesSuccess = createAction<ProductTileProps[]>(
  'favourites - fetch favourites success',
)
const fetchFavouritesFail = createAction<Error>('favourites - fetch favourites fail')

const fetchHiddenFavouritesStart = createAction('favourites - fetch hidden favourites start')
const fetchHiddenFavouritesSuccess = createAction<HiddenFavouritesData[]>(
  'favourites - fetch hidden favourites success',
)
const fetchHiddenFavouritesFail = createAction<Error>('favourites - fetch hidden favourites fail')

const showError = createAction<ErrorProps>('favourites - show error modal')
const hideError = createAction('favourites - hide error modal')

const deleteFavouritesItemStart = createAction<string>('favourites - delete favourites item start')
const deleteFavouritesItemSuccess = createAction('favourites - delete favourites item success')
const deleteFavouritesItemFail = createAction(
  'favourites - delete favourites item fail',
  (
    previousFavouritesItemsState: FavouritesState['items'],
    previousHiddenFavouritesItemsState: FavouritesState['hiddenItems'],
  ) => ({
    previousFavouritesItemsState,
    previousHiddenFavouritesItemsState,
  }),
)

const updateHiddenFavouritesItem = createAction(
  'favourites - updated the hidden favourites item',
  (updatedProductCode: string, productCode: string) => ({
    updatedProductCode,
    productCode,
  }),
)

const deleteHiddenFavouritesItem = createAction<string>(
  'favourites - delete favourites hidden item',
)

const moveToCartStart = createAction(
  'favourites - move to cart start',
  (variantCode: string) => variantCode,
)
const moveToCartSuccess = createAction('favourites - move to cart success')
const moveToCartFail = createAction(
  'favourites - move to cart fail',
  (
    previousFavouriteItemsState: FavouritesState['items'],
    previousHiddenFavouriteItemsState: FavouritesState['hiddenItems'],
  ) => ({
    previousFavouriteItemsState,
    previousHiddenFavouriteItemsState,
  }),
)

const showAddToBagVerificationStart = createAction('favourites - add to bag verification start')
const showAddToBagVerificationSuccess = createAction<AddToBagVerificationData>(
  'favourites - add to bag verification success',
)
const showAddToBagVerificationError = createAction(
  'favourites - add to bag verification error',
  (addToBagVerificationData: AddToBagVerificationData, error: Error) => ({
    addToBagVerificationData,
    error,
  }),
)

const hideAddToBagVerification = createAction('favourites - hide add to bag verification')

const updateVariantStart = createAction('favourites - update variant start')
const updateVariantSuccess = createAction(
  'favourites - update variant success',
  (newVariantCode: string, productCode: string) => ({
    newVariantCode,
    productCode,
  }),
)
const updateVariantFail = createAction(
  'favourites - update variant fail',
  (
    previousFavouriteItemsState: FavouritesState['items'],
    previousHiddenFavouriteItemsState: FavouritesState['hiddenItems'],
  ) => ({
    previousFavouriteItemsState,
    previousHiddenFavouriteItemsState,
  }),
)

const fetchStoreSearchResultsStart = createAction('favorites - fetch store search results start')
const fetchStoreSearchResultsSuccess = createAction(
  'favorites - fetch store search results success',
  ({ stores }) => ({
    stores,
  }),
)

const fetchStoreSearchResultsFail = createAction<Error>(
  'favorites - fetch store search results error',
)

const resetStoreSearchResultsStart = createAction('favorites - reset store search results start')
const resetStoreSearchResultsSuccess = createAction(
  'favorites - reset store search results success',
)
const resetStoreSearchResultsFail = createAction<Error>(
  'favorites - reset store search results error',
)

export default {
  fetchFavouritesStart,
  fetchFavouritesSuccess,
  fetchFavouritesFail,
  fetchHiddenFavouritesStart,
  fetchHiddenFavouritesSuccess,
  fetchHiddenFavouritesFail,
  deleteFavouritesItemStart,
  deleteFavouritesItemSuccess,
  deleteFavouritesItemFail,
  updateHiddenFavouritesItem,
  deleteHiddenFavouritesItem,
  moveToCartStart,
  moveToCartSuccess,
  moveToCartFail,
  showAddToBagVerificationStart,
  showAddToBagVerificationSuccess,
  showAddToBagVerificationError,
  hideAddToBagVerification,
  updateVariantStart,
  updateVariantSuccess,
  updateVariantFail,
  fetchStoreSearchResultsStart,
  fetchStoreSearchResultsSuccess,
  fetchStoreSearchResultsFail,
  resetStoreSearchResultsStart,
  resetStoreSearchResultsSuccess,
  resetStoreSearchResultsFail,
  showError,
  hideError,
}
